import {useState} from 'react';
import ProductService from '../../rest/productService';
import {BiPlusCircle, BiSearch} from 'react-icons/bi';
import MenuService from "../../rest/menuService";

const SearchComponent = ({onIngredientSelect, searchType}) => {
    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const handleSearchProduct = async (searchInput) => {
        try {
            const data = await ProductService.getProductsByInput(searchInput);
            setSearchResults(data);
        } catch (error) {
            console.error(error);
        }
    }

    const handleSearchAll = async (searchInput) => {
        try {
            const [recipes, products] = await Promise.all([
                MenuService.getRecipesByInput(searchInput),
                ProductService.getProductsByInput(searchInput)
            ]);

            const combinedResults = [...recipes, ...products];

            setSearchResults(combinedResults);
        } catch (error) {
            console.error(error);
        }
    }


    const handleIngredientSelect = (products) => {
        onIngredientSelect(products);
        setSearch('');
        setSearchResults([]);
    };

    const handleClearSearch = () => {
        setSearch('');
        setSearchResults([]);
    };

    return (
        <div className='mb-4'>
            <div className='flex items-center'>
                <input
                    type="search"
                    className='w-full h-10 px-4 text-sm border-2 border-slate-200 focus:border-blue-600 focus:outline-none'
                    placeholder="Pesquisar por nome do produto ou marca..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onClick={handleClearSearch}
                />
                <button className='bg-custom_blue text-white text-sm font-medium p-1 px-4 h-10 rounded-r'
                        type='button'
                        onClick={() => {
                            if (searchType === 'all') {
                                handleSearchAll(search)
                            } else if (searchType === 'products') {
                                handleSearchProduct(search)
                            }
                        }}>
                    <BiSearch className='scale-125'/>
                </button>
            </div>

            <div className='bg-slate-200 max-h-40 overflow-y-scroll'>
                {Array.isArray(searchResults) ? (
                    searchResults.map((product, index) => (
                        <div className='flex items-center justify-between border-b-2 border-slate-300 p-1 px-2'
                             key={index}>
                            <p>{product.name}</p>
                            <p className="text-custom_green scale-125"
                               onClick={() => handleIngredientSelect(product)}>
                                <BiPlusCircle/>
                            </p>
                        </div>
                    ))
                ) : (
                    <p>Nenhum resultado encontrado.</p>
                )}
            </div>

        </div>
    );
};

export default SearchComponent;
